<template>
    <div id="app">
        <main-header></main-header>
        <main class="adjuster">
            <div class="title">
                <h2>{{ title }}</h2>
                <a-tag v-if="_public"><a-icon type="share-alt" />公开列表</a-tag>
                <a-tag v-else><a-icon type="lock" />私人列表</a-tag>
            </div>
            <div>
                {{ intro }}
            </div>
            <div class="list-container">
                <list-tower-card v-for="item of list" :key="item.name" :tower="item" />
            </div>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import Footer from '@/components/Footer'
import { getSSRdata } from '../../utils/utils'
import ListTowerCard from './ListTowerCard.vue'

export default {
    data: () => ({
        list: [],
        _public: 0,
        privilege: 1,
    }),
    created() {
        const { code, title, intro, list, public: _public, privilege } = getSSRdata("list");
        this.code = code;
        if (this.code != 0) return;

        this.title = title;
        this.intro = intro;
        this._public = _public;
        this.privilege = privilege;
        this.list = list;
    },
    components: {
        MainHeader, Footer,
        ListTowerCard,
    }
}
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.title {
    text-align: left;
    h2 {
        display: inline-block;
        margin: 20px;
        font-size: 32px;
    }
}
.adjuster {
    margin: 20px auto;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
}
</style>